'use client';
// Import Modules
import { useState } from 'react';
import Image, { StaticImageData } from 'next/image';

// People Assets
import JS from '@/assets/images/Employees/JS.jpg';
import KT from '@/assets/images/Employees/KT.png';
// import RJSRandhawa from "@/assets/images/Employees/RaminderJeetSinghRandhawa.png";
import Momo from '@/assets/images/Employees/Momo.jpg';
import Manan from '@/assets/images/Employees/Manan.jpg';
import PSJ from '@/assets/images/Employees/PSJ.jpeg';
import Richa from '@/assets/images/Employees/Richa.jpg';
import VishalJain from '@/assets/images/Employees/VishalJain.png';

interface LeadershipTeamItem {
  name: string;
  role: string;
  profile: StaticImageData;
  description: string;
}

const leadershipTeam: LeadershipTeamItem[] = [
  {
    name: 'Sambhav Anand Jain',
    role: 'Director & CEO',
    profile: JS,
    description:
      'Sambhav Anand Jain is the CEO and co-founder and part of the core management team at Tri O Tech, the authorised PPI issuer operating the digital payments app FamApp by Trio. Sambhav is a graduate of IIT Roorkee, he has been featured in the Forbes 30 Under 30 Asia 2021 list for his pioneering contributions to youth-focused fintech innovation. Under his leadership, FamApp was honoured with the Emerging UPI Player Award, presented by Finance Minister Nirmala Sitharaman. In his mission to drive a digital India, Sambhav works closely with government bodies and major financial institutions, including NPCI, UIDAI, and leading banks. Recognized as an industry leader, he is at the forefront of revolutionizing how India’s youth access secure and hassle-free digital payment services.',
  },
  {
    name: 'Kush Taneja',
    role: 'Director',
    profile: KT,
    description:
      'Kush Taneja is a director at Tri O Tech, co-founder of FamApp by Trio and an innovator in the fintech industry. He shares a vision of making digital payments accessible to the youth of India and empowering them through seamless and inclusive financial solutions. He has been featured in the Forbes 30 Under 30 Asia 2021 list.',
  },
  {
    name: 'Anchit Shukla',
    role: 'Director',
    profile: Momo,
    description:
      'Anchit Shukla leads Product and KYC at the company, driving innovation in customer onboarding, verification, and platform security. He also oversees risk and fraud strategy, ensuring a trusted and compliant user experience. An alumnus of IIT Roorkee, Anchit was part of the founding team at FamApp, where he played a key role in shaping product vision and scaling systems. His expertise spans fintech product development, digital identity, and risk management in high-growth environments.',
  },
  // {
  //   name: "RJS Randhawa",
  //   role: "Advisor - Regulatory and Compliance",
  //   profile: RJSRandhawa,
  //   description:
  //     "Raminder Jeet Singh Randhawa is a seasoned banker with over 33 years of distinguished service at the State Bank of India (SBI), where he began his career as a Probationary Officer in 1983. An alumnus of the Faculty of Management Studies (FMS), University of Delhi, Mr. Randhawa holds an MBA in Finance and has extensive experience across the Retail, International, and Corporate Banking verticals of SBI. In the later phase of his career, he was deputed as General Manager to the Central Registry of Securitisation Asset Reconstruction and Security Interest of India (CERSAI) under the Department of Financial Services (DFS), Ministry of Finance, Government of India. At CERSAI, he played a pivotal role in the creation and stabilization of the Central KYC Registry (CKYCR). Following his superannuation, he continued his association with CERSAI as an Advisor for an additional three years. Throughout his tenure, Mr. Randhawa has been actively involved in high-level deliberations with key government departments, regulators, and investigative agencies, contributing significantly to the development and refinement of India’s KYC framework. His deep insights into financial compliance and regulatory processes culminated in his close involvement with the Expert Committee on KYC, constituted by the Government of India under the chairmanship of Mr. M. Rajeshwar Rao, Deputy Governor, Reserve Bank of India.",
  // },
  {
    name: 'Prasanjeet Patil',
    role: 'Head, Legal and Policy and Escalation Officer',
    profile: PSJ,
    description:
      'Prasanjeet Patil brings over seven years of dedicated experience as a fintech lawyer. Prior to joining Tri O Tech, he worked with leading law firms including Samvad Partners, Mumbai, and MCM Law, Bengaluru. He is a graduate of Symbiosis Law School, Pune. Throughout his career, Prasanjeet has advised a wide spectrum of regulated financial entities—such as NBFCs, PPI issuers, LSPs, and payment aggregators/gateways—on complex regulatory and compliance matters. His expertise spans fintech licensing, digital lending, payments regulations, and RBI-compliance frameworks. At Tri O Tech, Prasanjeet heads the Legal and Compliance function and also serves as the Company’s Escalation Officer, ensuring robust regulatory governance and operational integrity across the organization.',
  },
  {
    name: 'Vishal Jain',
    role: 'Head, Finance',
    profile: VishalJain,
    description:
      'Vishal Jain is a seasoned finance leader with over 15 years of experience across fintech, e-commerce, and mobility sectors. An ISB alumnus and CFA (US), CA, CS, he currently serves as Head of Finance at Tri O Tech Solutions Pvt. Ltd. He has successfully led fund-raising initiatives, strategic finance, M&A, and business transformation, driving growth, profitability, and financial governance across leading startups including Myntra, Bounce, and FamPay.',
  },
  {
    name: 'Richa Khandelwal',
    role: 'Principal Nodal Officer and Company Secretary',
    profile: Richa,
    description:
      'Richa Khandelwal is a qualified member of the Institute of Company Secretaries of India (ICSI) and currently oversees regulatory compliance at Tri O Tech. She also serves as the Nodal Officer of the Company. With over 10 years of extensive experience, Richa specializes in managing RBI compliances related to PPI, NBFC, and FEMA regulations. She is also a pioneer in handling diverse corporate and regulatory compliances applicable to companies under various statutory frameworks.',
  },
  {
    name: 'Manan Vishal Manocha',
    role: 'Secondary Nodal Officer and Head - Customer Support and Operations',
    profile: Manan,
    description:
      'Manan Manocha is a seasoned customer experience and operations leader with deep expertise in building scalable support systems for high-growth fintech companies. He previously served as the Head of Customer Service at Slice for five years, where he led customer support strategy and operations and also served as the Nodal Officer. During his tenure, Manan played a key role in developing robust and scalable service frameworks, driving regulatory compliance, and leading customer-first initiatives that strengthened Slice’s reputation for exceptional service in the fintech ecosystem. Manan currently serves as the Head of Support at FamApp.',
  },
];

const LeadershipCard = ({ item }: { item: LeadershipTeamItem }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="group rounded-3xl bg-linear-to-b from-orange-500 to-green-500 p-[0.5px] w-full max-w-[300px] h-full">
      <div className="flex flex-col items-center justify-between bg-white rounded-3xl p-8 h-full relative transition-transform duration-300 group-hover:shadow-lg group-hover:scale-[1.02]">
        <Image
          className="rounded-full w-36 h-36 object-cover"
          src={item.profile}
          alt={item.name}
          width={144}
          height={144}
        />
        <div className="flex flex-col items-center text-center grow justify-center relative w-full">
          <h2 className="text-trio-black my-3 font-extrabold w-full group-hover:text-orange-600 transition-colors">
            {item.name}
          </h2>
          <hr className="bg-black w-full opacity-100" />
          <p className="text-trio-black my-3 font-semibold w-full">{item.role}</p>
          <div className="relative w-full">
            <p
              className={`text-trio-black text-sm transition-all duration-500 ease-in-out group-hover:text-orange-600 ${
                expanded
                  ? 'line-clamp-none'
                  : 'line-clamp-2 sm:line-clamp-3 md:line-clamp-4 group-hover:line-clamp-none'
              }`}
            >
              {item.description}
            </p>
          </div>
          <button
            onClick={() => setExpanded((prev) => !prev)}
            className="text-orange-600 mt-3 text-sm font-semibold hover:underline focus:outline-hidden"
          >
            {expanded ? 'Show less' : 'Show more'}
          </button>
        </div>
      </div>
    </div>
  );
};

const Leadership = () => {
  return (
    <div className="flex flex-wrap gap-6 px-4 justify-center w-full">
      {leadershipTeam.map((item) => (
        <LeadershipCard item={item} key={item.name} />
      ))}
    </div>
  );
};

export default Leadership;
